var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoteMultiOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.812 33.978V2.599H13.047v3.019l-6.849.963.445 3.166-6.671 1.913 8.65 30.164 26.643-7.64 1.46-.205zM15.662 5.214h23.535v26.149H15.662zm-2.615 2.797v25.967h6.65l-7.114 1-3.708-26.38zm-2.8 30.881L2.904 13.285l4.073-1.168 3.589 25.539 7.837-1.102zM85.708 14.009l-7.769-1.233-3.474-7.686-3.474 7.686-7.769 1.233 5.622 5.983-1.327 8.448 6.949-3.988 6.949 3.988-1.327-8.448zm-11.243 8.546-4.907 2.817.937-5.966-3.97-4.225 5.486-.87 2.454-5.428 2.454 5.428 5.486.87-3.97 4.225.937 5.966z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.418 12.8-9.413 9.413h-3.486v-3.486l9.413-9.413zm1.177-1.177-3.486-3.486 1.221-1.221a1.05 1.05 0 0 1 1.479 0l2.007 2.007a1.05 1.05 0 0 1 0 1.479zm-2.92 6.136v7.243H19.731V11.057h7.67l2.789-2.789H19.034a2.1 2.1 0 0 0-2.092 2.092v15.339c0 1.151.941 2.092 2.092 2.092h15.339a2.1 2.1 0 0 0 2.092-2.092V15.255z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteMultiOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note-multi-off.svg";